import { IWarehouseConnectionRepository } from '@domain/inventory/IWarehouseConnectionRepository';
import { Resource } from '@domain/base/Resource';
import { WarehouseConnection } from '@domain/inventory/models/WarehouseConnection';
import { WarehouseConnectionDataSource } from '../datasources/WarehouseConnectionDataSource';
import { WarehouseConnectionRule } from '@domain/inventory/models/WarehouseConnectionRule';
import { MutationType } from '@domain/inventory/enums/MutationType.enum';

export class WarehouseConnectionRepository implements IWarehouseConnectionRepository {
    constructor(private dataSource: WarehouseConnectionDataSource) { }

    async createConnection(
        warehouseId: string,
        rules: WarehouseConnectionRule[],
        type: MutationType,
        activeFrom?: Date,
        activeUntil?: Date,
        shouldCreateMutations: boolean = true
    ): Promise<Resource<WarehouseConnection>> {
        try {

            if (!activeFrom) {
                activeFrom = new Date(new Date().setHours(0, 0, 0, 0));
            }
            
            const data = await this.dataSource.createWarehouseConnection(
                warehouseId,
                rules,
                type,
                activeFrom,
                activeUntil
            );
            return { status: 'success', data };
        } catch (error) {
            return {
                status: 'error',
                error: {
                    type: 'UnknownError',
                    message: 'Failed to create warehouse connection'
                }
            };
        }
    }

    async getConnections(warehouseId: string): Promise<Resource<WarehouseConnection[]>> {
        try {
            const data = await this.dataSource.getWarehouseConnections(warehouseId);
            return { status: 'success', data };
        } catch (error) {
            return {
                status: 'error',
                error: {
                    type: 'UnknownError',
                    message: 'Failed to get warehouse connections'
                }
            };
        }
    }

    async deleteConnection(id: string): Promise<Resource<void>> {
        try {
            await this.dataSource.deleteWarehouseConnection(id);
            return { status: 'success', data: undefined };
        } catch (error) {
            return {
                status: 'error',
                error: {
                    type: 'UnknownError',
                    message: 'Failed to delete warehouse connection'
                }
            };
        }
    }

    async updateConnection(
        id: string,
        rules: WarehouseConnectionRule[],
        mutationType: MutationType,
        activeFrom?: Date,
        activeUntil?: Date
    ): Promise<Resource<WarehouseConnection>> {
        try {
            const updatedData = await this.dataSource.updateWarehouseConnection(id, rules, mutationType, activeFrom, activeUntil);
            return { status: 'success', data: updatedData };
        } catch (error) {
            return {
                status: 'error',
                error: {
                    type: 'UnknownError',
                    message: 'Failed to update warehouse connection'
                }
            };
        }
    }
} 